import { createStore, applyMiddleware, compose } from 'redux';
import thunkMiddleware from 'redux-thunk';
import apiMiddleware from 'middlewares/api';
import formMiddleware from 'middlewares/form';
import { createLogger } from 'redux-logger';
import offersRootReducer from '../reducers/products';
import linksRootReducer from '../reducers/links';
import instapayRootReducer from '../reducers/instapay';
import responseRootReducer from '../reducers/paymentResponse';

const logger = createLogger({
  level: 'info',
  collapsed: false,
});

const createStoreWithMiddleware = compose(
  applyMiddleware(
    thunkMiddleware,
    apiMiddleware,
    formMiddleware,
  ),
  applyMiddleware(logger)
)(createStore);


/**
 * Create a preconfigured store with middlewares
 */
export default function configureStore() {
  /* globals INITIAL_STATE */
  let rootReducer;
  if (INITIAL_STATE.is_payment_response) {
    rootReducer = responseRootReducer;
  }
  else if (INITIAL_STATE.is_link_payment) {
    rootReducer = linksRootReducer;
  }
  else if (INITIAL_STATE.is_instapay_payment) {
    rootReducer = instapayRootReducer;
  }
  else {
    rootReducer = offersRootReducer;
  }

  return createStoreWithMiddleware(rootReducer);
}



// WEBPACK FOOTER //
// ./src/payments/store/ConfigStore.js